// extracted by mini-css-extract-plugin
module.exports = {"tag":"DiscountTag-module__tag___2-Wjm","on-sale-tag":"DiscountTag-module__on-sale-tag___V7wuC","discount-tag":"DiscountTag-module__discount-tag___vLygX"};